export const Types = {
  searchVoucher: 'voucher/SEARCH_VOUCHER',
  updateActiveVoucher: 'voucher/UPDATE_VOUCHER',
  setVoucherRedeemed: 'voucher/SET_VOUCHER_REDEEMED',
  updateVoucherRedeemed: 'voucher/UPDATE_VOUCHER_REDEEMED',
  getReserves: 'voucher/GET_RESERVES',
  updateReserves: 'voucher/UPDATE_RESERVES',
  updateNewConsumer: 'voucher/UPDATE_NEW_CONSUMER'
}

export function searchVoucher ({ campaignId, storeId, voucherCode, consumerCpf } = {}) {
  return {
    type: Types.searchVoucher,
    payload: { campaignId, storeId, voucherCode, consumerCpf }
  }
}

export function updateActiveVoucher ({ voucher, error } = {}) {
  return {
    type: Types.updateActiveVoucher,
    payload: { voucher, error }
  }
}

export function setVoucherRedeemed ({ campaignId, storeId, voucherCode, employeeCpf, employeeType, metadata } = {}) {
  return {
    type: Types.setVoucherRedeemed,
    payload: { campaignId, storeId, voucherCode, employeeCpf, employeeType, metadata }
  }
}

export function updateVoucherRedeemed ({ redeemed = false, data = {}, error } = {}) {
  return {
    type: Types.updateVoucherRedeemed,
    payload: { redeemed, data, error }
  }
}

export function getReserves ({ campaignId, storeId, redemptionDate } = {}) {
  return {
    type: Types.getReserves,
    payload: { campaignId, storeId, redemptionDate }
  }
}

export function updateReserves ({ reserves, error } = {}) {
  return {
    type: Types.updateReserves,
    payload: { reserves, error }
  }
}

export function updateNewConsumer ({ newConsumer } = {}) {
  return {
    type: Types.updateNewConsumer,
    payload: { newConsumer }
  }
}
